import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import {
  AwardPreparationTrainingsTable,
  AwardUsersPreparationTrainings
} from 'components/sections/awards'
import { FloatingBar, FormButton } from 'components/misc'
import { form } from 'helpers/decorators'

@form({
  form: 'edit-participants-trainings-form',
  initialProps: 'awards.preparationTrainings',
  initialPropsMapper: props => {
    return {
      trainings: [...props]
    }
  }
})
class ParticipantsPreparationTrainings extends Component {
  static propTypes = {
    awards: PropTypes.object.isRequired,
    addPreparationTraining: PropTypes.func.isRequired,
    removePreparationTraining: PropTypes.func.isRequired,
    editPreparationTraining: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    values: PropTypes.object
  }

  static defaultProps = {
    values: {}
  }

  render() {
    const {
      awards,
      addPreparationTraining,
      removePreparationTraining,
      editPreparationTraining,
      handleSubmit,
      values
    } = this.props

    return (
      <form
        onSubmit={handleSubmit(fields =>
          editPreparationTraining(get(awards, 'detail.id'), fields)
        )}
      >
        <AwardPreparationTrainingsTable
          loading={awards.loading}
          list={values.trainings}
          {...this.props}
        />
        <AwardUsersPreparationTrainings
          awardId={awards.detail.id}
          collection={awards.preparationTrainings}
          list={values.trainings}
          addPreparationTraining={addPreparationTraining}
          removePreparationTraining={removePreparationTraining}
          modal={this.props.modal}
        />
        <FloatingBar>
          <FormButton {...this.props} intlKey="button.save">
            Save
          </FormButton>
        </FloatingBar>
      </form>
    )
  }
}

export default ParticipantsPreparationTrainings
